export default "__VITE_ASSET__sSIu7fA0__"